import React from 'react';
import ReactMarkdown from 'react-markdown';

const ASSISTANT_ELEMENTS = [
    'h1', 'h2', 'h3', 'h4', 'p', 'strong', 'em', 'ol', 'ul', 'li', 'pre', 'code', 'br',
];

/** Safe, deliberately small Markdown surface for assistant responses only. */
export function AssistantMessage({ children }) {
    return (
        <div className="help-markdown">
            <ReactMarkdown allowedElements={ASSISTANT_ELEMENTS}>{children || ''}</ReactMarkdown>
        </div>
    );
}

/** User text is always rendered literally; it is never interpreted as Markdown. */
export function UserMessage({ children }) {
    return <>{children}</>;
}
